<app-heading [title]="contractorTimekeepingEnabled ? 'Invoice Generator' : 'Timekeeping'" [button]="false" [isbreadcrumb]="false" [showToggle]="false"></app-heading>
<div class="flex flex-column gap-4">
    <div class="lg:w-28rem w-full">
        <p-dropdown inputId="role" [(ngModel)]="selectedRole" (onChange)="onRoleChange($event)" [options]="roles"
            optionLabel="name" [placeholder]="'Select Role' | sentenceCase" />
    </div>
    <div class="grid">
        <div class="col-12 xl:col-6">
            <p-card role="region" styleClass="nogutter-content">
                <div class="flex flex-column gap-4">
                    <div class="flex justify-content-between align-items-center">
                        <span class="h6">{{'Time Tracked Today' | sentenceCase}}</span>
                        <div class="text-black-alpha-60">
                            <span class="text-sm">Date: </span>
                            <span class="text-xs font-medium">{{todayDate | date:'MM-dd-yyyy'}}</span>
                        </div>
                    </div>
                    <div class="flex justify-content-between flex-column md:flex-row md:gap-0 gap-4">
                        <span
                            class="h3">{{dailyDuration?.hours}}:{{dailyDuration?.minutes}}:{{dailyDuration?.seconds}}</span>
                        @if(selectedRole && selectedRole.value){
                            <div class="flex gap-2 align-items-center">
                            @if(!isClockedIn){
                                <p-button (click)="clockIn()" styleClass="teal white-space-nowrap"  label="start time" rounded="true" size="large"
                                    ></p-button>
                            }
                            @if(isClockedIn){
                                <p-button (click)="clockOut()" label="stop time" rounded="true" size="large"
                                    styleClass="red-background white-space-nowrap"></p-button>
                            }
                            <p-button (click)="openAddTimeModal()" label="add time" rounded="true" size="large"
                                styleClass="white-space-nowrap" outlined="true"></p-button>
                            <p-dialog header="Edit time record" [modal]="true" [(visible)]="showTimeSheetEditor"
                                [draggable]="false" styleClass="xl:w-6 w-9">
                                @if(showTimeSheetEditor){
                                <app-timesheet-editor (closeModal)="closeModal($event)" [data]="selectedTimeSheet"
                                    [isEdit]="isTimeSheetEditable" [roles]="roles"
                                    [selectedRole]="selectedRole"></app-timesheet-editor>
                                }
                            </p-dialog>
                            </div>
                        }
                    </div>
                </div>
            </p-card>
        </div>
        <div class="col-12 xl:col">
            <p-card role="region" styleClass="nogutter-content">
                <div class="flex flex-column gap-4">
                    <span class="h6">{{'Week Total' | sentenceCase}}</span>
                    <span class="h3">{{weekDuration?.hours}}:{{weekDuration?.minutes}}</span>

                </div>
            </p-card>
        </div>
        <div class="col-12 xl:col">
            <p-card role="region" styleClass="nogutter-content">
                <div class="flex flex-column gap-4">
                    <span class="h6">{{'Role Total' | sentenceCase}}</span>
                    <span class="h3">{{totalDuration?.hours}}:{{totalDuration?.minutes}}</span>
                </div>
            </p-card>
        </div>
    </div>
    <div class="flex justify-content-between md:align-items-center">
        <span class="h6">{{'Time Tracked Today' | sentenceCase}}</span>
        <p-button (click)="getTsheetList(this.navigatedWeek)" label="refresh" rounded="true" size="large"
            icon="pi pi-sync" styleClass="white-space-nowrap" outlined="true"></p-button>
    </div>
    <div class="flex flex-column xl:flex-row justify-content-between xl:align-items-center gap-4 xl:gap-0">
        <div class="flex gap-4 align-items-center justify-content-between">
            <span (click)="setCurrentWeek()" class="white-space-nowrap text-primary font-medium cursor-pointer">This week</span>
            <div class="flex align-items-center gap-2 justify-content-between">
                <p-button (click)="getPreviousWeekList()" type="button" pRipple [text]="true" [rounded]="true"
                    [plain]="true" icon="pi pi-chevron-left" />
                <span class="white-space-nowrap">
                    {{navigatedWeek.startDate.format('MM/DD/YYYY')}} - {{navigatedWeek.endDate.format('MM/DD/YYYY')}}
                </span>
                @if(ifWeekLimitNotReach()){
                <p-button (click)="getNextWeekList()" type="button" pRipple [text]="true" [rounded]="true"
                    [plain]="true" icon="pi pi-chevron-right" />
                }
            </div>
        </div>
        <div class="flex gap-2 align-items-center">
            @if(displayApproveTime && contractorTimekeepingEnabled){
                <p-button (click)="approveTime($event)" label="approve time" rounded="true" size="large"
                    styleClass="teal white-space-nowrap"></p-button>
            }
            @if(contractorTimekeepingEnabled){
                <p-button (click)="submitInvoice($event)" label="submit invoice" rounded="true" size="large"
                    styleClass="teal white-space-nowrap"></p-button>
                <p-button label="view invoice" rounded="true" size="large" styleClass="white-space-nowrap" outlined="true"
                    (click)="showDialog()"></p-button>
            }
            <p-dialog header="Invoices" [modal]="true" [(visible)]="visible" [draggable]="false"
                styleClass="md:w-6 w-full">
                <span class="flex gap-4 text-sm font-medium mb-3">
                    <span>Role : {{selectedRole.name}} </span>
                    <span>Week: {{navigatedWeek.startDate.format('MM/DD/YYYY')}} - {{navigatedWeek.endDate.format('MM/DD/YYYY')}}</span>
                </span>
                <div class="flex align-items-center gap-3 mb-3">
                    <p-table [value]="invoices" dataKey="id" styleClass="p-datatable-sm p-datatable-sm--normal"
                        class="w-full" [rows]="7" autoLayout="true" [scrollable]="true">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>S.No</th>
                                <th>{{'Submitted On' | sentenceCase}}</th>
                                @if (helperService.checkResponsive()) {
                                    <th alignFrozen="right" pFrozenColumn>
                                      <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                    </th>
                                    } @else {
                                    <th class="w-10rem">
                                      <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                    </th>
                                }
                                <ng-template #frozenHeader>
                                Actions
                                </ng-template>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-invoice let-rowIndex="rowIndex">
                            <tr>
                                <td>{{rowIndex+1}}</td>
                                <td>{{invoice.createdAt | date: "MM/dd/yyyy hh:mm:ss a"}}</td>
                                @if (helperService.checkResponsive()) {
                                    <td alignFrozen="right" pFrozenColumn>
                                      <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                                    </td>
                                  } @else {
                                    <td>
                                      <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                                    </td>
                                  } 
                                 <ng-template #frozenData>
                                    <div class="wrap-actions">
                                        <p-button (click)="getInvoiceUrl(invoice._id.toString())" [rounded]="true" [text]="true" icon="true"
                                            styleClass="text-primary-900">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-download-outlined"></span>
                                        </p-button>
                                </div>
                                 </ng-template>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-dialog>
        </div>
    </div>
    <div>
        <p-table [value]="tsheets" dataKey="_id" styleClass="p-datatable-sm p-datatable-sm--normal" [rows]="7"
            [tableStyle]="{ 'min-width': '50rem' }"  autoLayout="true" [scrollable]="true">
            <ng-template pTemplate="header">
                <tr>
                    <th>Day</th>
                    <th>{{'Start Time' | sentenceCase}}</th>
                    <th>{{'End Time' | sentenceCase}}</th>
                    <th>Hours</th>
                    <th>Roles</th>
                    <th>Notes</th>
                    @if (helperService.checkResponsive()) {
                        <th alignFrozen="right" pFrozenColumn>
                            <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                        </th>
                        } @else {
                        <th>
                            <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                        </th>
                    }
                    <ng-template #frozenHeader>
                        Actions
                    </ng-template>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-tsheet let-rowIndex="rowIndex">
                <tr>
                    <td>{{day(tsheet.start)}}</td>
                    <td>{{dateTime(tsheet.start)}} {{timezone}}</td>
                    <td>{{tsheet.onTheClock ? 'working' : dateTime(tsheet.end)+' '+timezone}}</td>
                    <td> {{secondsToDecimal(tsheet.duration) || 0}}</td>
                    <td> {{tsheet.role.roleType}}</td>
                    <td>{{slimNotes(tsheet.notes)}}</td>
                    @if (helperService.checkResponsive()) {
                        <td alignFrozen="right" pFrozenColumn>
                          <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                        </td>
                      } @else {
                        <td>
                          <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                        </td>
                      } 
                     <ng-template #frozenData>
                        <div class="flex">
                            <p-button (click)="editTimeSheet(tsheet)" [rounded]="true" [text]="true" icon="true"
                                styleClass="text-primary-900 p-0">
                                <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                            </p-button>
                            <p-button styleClass="red-icon p-0" (click)="deleteInvoice($event,tsheet, rowIndex)" [rounded]="true" [text]="true"
                                icon="true">
                                <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                            </p-button>
                        </div>
                     </ng-template>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>